import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, map } from 'rxjs/operators';
import { UserService } from 'src/api';
import * as UserActions from './actions';

@Injectable()
export class UserEffects {
  private readonly actions$ = inject(Actions);
  private readonly userService = inject(UserService);

  loadUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserActions.LoadUser),
      exhaustMap(() =>
        this.userService.getCurrentUser().pipe(map((user) => UserActions.SetUser({ user }))),
      ),
    ),
  );
}
